"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidStudentKey = exports.invalidTeacherKey = exports.classKey = exports.studentKey = exports.teacherKey = exports.schoolKey = exports.UserError = exports.SchoolEntityTypes = void 0;
var SchoolEntityTypes;
(function (SchoolEntityTypes) {
    SchoolEntityTypes["School"] = "school";
    SchoolEntityTypes["Class"] = "class";
    SchoolEntityTypes["Student"] = "student";
    SchoolEntityTypes["Teacher"] = "teacher";
    SchoolEntityTypes["InvalidStudent"] = "invalid-student";
    SchoolEntityTypes["InvalidTeacher"] = "invalid-teacher";
})(SchoolEntityTypes = exports.SchoolEntityTypes || (exports.SchoolEntityTypes = {}));
var UserError;
(function (UserError) {
    UserError["NoEmail"] = "NoEmail";
    UserError["InvalidEmail"] = "InvalidEmail";
    UserError["EmailNotMatchingSchoolPattern"] = "EmailNotMatchingSchoolPattern";
    UserError["DuplicateUser"] = "DuplicateUser";
    UserError["DuplicateStudentTeacher"] = "DuplicateStudentTeacher";
    UserError["NonTeachingStaff"] = "NonTeachingStaff";
    UserError["SyncedToOtherSchool"] = "SyncedToOtherSchool";
})(UserError = exports.UserError || (exports.UserError = {}));
const entityKey = (entityType) => (entityId) => `${entityType}-${entityId}`;
exports.schoolKey = entityKey(SchoolEntityTypes.School);
exports.teacherKey = entityKey(SchoolEntityTypes.Teacher);
exports.studentKey = entityKey(SchoolEntityTypes.Student);
exports.classKey = entityKey(SchoolEntityTypes.Class);
exports.invalidTeacherKey = entityKey(SchoolEntityTypes.InvalidTeacher);
exports.invalidStudentKey = entityKey(SchoolEntityTypes.InvalidStudent);
//# sourceMappingURL=common.js.map